module.exports = __webpack_public_path__ + "img/10.990c406b.jpg";